import { useStore } from "@/stores/useStore";
import { useEffect, useState } from "react";
import { UniqueIdentifier } from "@dnd-kit/core";
import { Card } from "@/types/v2";

export const useCard = (id?: string | UniqueIdentifier) => {
  const { cards } = useStore();
  const [card, setCard] = useState<Card | undefined>(undefined);

  useEffect(() => {
    setCard(cards?.find((c) => c.id === id));
  }, [cards, id]);

  return { card, setCard };
};
